var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTaskIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7,2.3c-3.1-3.1-8.2-3.1-11.3,0C0.8,3.9,0,5.9,0,8s0.8,4.1,2.3,5.7C3.9,15.2,6,16,8,16s4.1-0.8,5.7-2.3 C16.8,10.5,16.8,5.5,13.7,2.3z M13,13c-2.7,2.7-7.2,2.7-9.9,0C1.7,11.6,1,9.9,1,8S1.7,4.4,3,3C4.4,1.7,6.2,1,8,1s3.6,0.7,5,2.1 C15.7,5.8,15.7,10.2,13,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,7.5L8.5,7.5l0.1-2.8c0-0.3-0.2-0.5-0.5-0.5c-0.2,0-0.5,0.2-0.5,0.5L7.5,7.5L4.7,7.6 c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0l2.8-0.1l-0.1,2.8c0,0.3,0.2,0.5,0.5,0.5c0,0,0,0,0,0 c0.3,0,0.5-0.2,0.5-0.5l0.1-2.9l2.9-0.1c0.3,0,0.5-0.2,0.5-0.5C11.8,7.7,11.6,7.4,11.3,7.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTaskIcon);
export default __webpack_public_path__ + "static/media/add-task-icon.9d12130c71bce7593d4a99b9bbf290ee.svg";
export { ForwardRef as ReactComponent };